import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TabCommunicationService {
  private activeTabSubject = new BehaviorSubject<string>('general');
  public activeTab$ = this.activeTabSubject.asObservable();

  setActiveTab(tabId: string): void {
    this.activeTabSubject.next(tabId);
  }

  getCurrentTab(): string {
    return this.activeTabSubject.value;
  }
}
